import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { withStyles, Grid } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import { IconButton } from '../default'
import CardPaper from './CardPaper'
import { CreateFilterModal } from '../modal'
import { acSetFiltersModal } from '../../class/actions'
import { DB_CONST } from '../../class/constants'

function CardFilter({
    classes, currentFiltersModal
}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const loadCreateFilter = () => {
        dispatch(acSetFiltersModal(DB_CONST.FILTER_MODALS.CREATE))
    }

    return (
        <div className={classes.form}>
            <CreateFilterModal
                open={currentFiltersModal === DB_CONST.FILTER_MODALS.CREATE}
                onClose={() => dispatch(acSetFiltersModal(null))}
            />

            <Grid container spacing={1}>

                <Grid item xs={3} className={classes.gridItem}>
                    <CardPaper style={{ width: '100%', height: '100%' }}>
                        <IconButton
                            className={classes.formField}
                            onClick={loadCreateFilter}
                            icon={Add}
                        >
                            {t('cards.filters.btnCreate')}
                        </IconButton>
                    </CardPaper>
                </Grid>

            </Grid>
        </div>
    )
}

CardFilter.propTypes = {
    onSearch: PropTypes.func,
}

CardFilter.defaultProps = {
    onSearch: () => true
}

const styles = theme => ({
    header: {
        textAlign: 'center'
    },
    form: {
        display: 'flex',
        alignItems: 'center'
    },
    formField: {
        width: '100%',
        height: '100%'
    },
    gridItem: {
        display: 'flex',
        alignItems: 'flex-start'
    }
})

const mapStateToProps = ({ ReducerFilter }) => ({
    currentFiltersModal: ReducerFilter.currentFiltersModal
})

export default connect(mapStateToProps)(withStyles(styles)(CardFilter))